// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import CyphrVoid from './pages/CyphrVoid';
import About from "./pages/About";
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import './Styles/App.css';

function App() {
    return (
        <div className="app-container">
            <Router>
                <Navigation />
                <div className="content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element= {<About />} />
                        <Route path="/void" element={<CyphrVoid />} />
                        <Route path="/privacy" element={<Privacy />} />
                    </Routes>
                </div>
                <Footer />
            </Router>
        </div>
    );
}

export default App;